/* eslint-disable camelcase */
// Loaded from the /contexts API endpoint.

import { ApplicantPortalService } from 'api-clients/monolith';
import React from 'react';

export interface RouteParams {
  accountSlug: string;
  applicantExternalId: string;
}

export type ContextResponse = Awaited<
  ReturnType<
    typeof ApplicantPortalService.getInternalApiPortalApplicationsContexts
  >
>;

export type AppContextData = ContextResponse & RouteParams;

export const defaultContext = {
  account: {
    name: 'stub',
    slug: 'stub',
    external_id: 'abc',
    account_type: 'demo',
  },
  brand: {
    name: 'stub',
    external_id: 'stub-id',
    slug: 'brand-stub',
    colors: {
      primary: '#3f7fe9',
      secondary: '#8e56a6',
      white: '#ffffff',
      primary_dark: '#453f2c',
      grey_1: 'hsl(217, 8%, 17%)',
      grey_2: 'hsl(217, 2%, 47%)',
      grey_3: 'hsl(217, 3%, 71%)',
      grey_4: 'hsl(217, 6%, 87%)',
      grey_5: 'hsl(217, 33%, 97%)',
      grey_6: 'hsl(220, 7%, 17%)',
      box_shadow_1: 'hsla(217, 2%, 47%, 0.24)',
      box_shadow_2: 'hsla(217, 2%, 47%, 0.08)',
      input_inset: 'inset 0 1px 3px 0 hsla(217, 6%, 87%, 0.7)',
      dropdown_inset: 'inset 0 -1px 3px 0 hsla(217, 6%, 87%, 0.7)',
      input_outline: '0 0 0 3px hsla(217, 3%, 71%, 0.12)',
      gray600: '#666f89',
    },
    logo_url: 'fake_logo.png',
  },
  config: {
    cookie_consent_enabled: false,
    experiments: [],
    ax_faq_widget_enabled: false,
  },
  funnel: {
    title: 'Opening name',
    external_id: 'stub-external-id',
    slug: 'stub-funnel',
    locale: 'en-US',
    alternative_locales: {}, // possible locales in the form of a hash { 'en-EN': true, 'fr-FR': false }
    company_support_email: 'help@company.com',
    location: {
      name: 'location',
      external_id: 'external-id',
      time_zone: 'America/Los_Angeles',
    },
    custom_fields: [],
  },
  applicant: { time_zone: null, phone_number: 'fake_number' },
  accountSlug: 'stub_account',
  applicantExternalId: 'stub_applicant_external_id',
};

export const AppContext = React.createContext<AppContextData>(defaultContext);
